import script from "./KurulScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./KurulScreen.vue?vue&type=script&setup=true&lang=js"

import "./KurulScreen.vue?vue&type=style&index=0&id=860fc802&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-860fc802"]])

export default __exports__